const fault = {
  state: {
    faultObj: {},
    faultkeywords: [],
    keywordsByFault: []
  },
  getters: {
    faultObj: state => state.faultObj,
    faultkeywords: state => state.faultkeywords,
    keywordsByFault: state => state.keywordsByFault
  },
  mutations: {
    SET_FAULT_OBJ: (state, faultObj) => {
      state.faultObj = faultObj
    },
    SET_KEYWORDS: (state, faultkeywords) => {
      state.faultkeywords = faultkeywords
    },
    SET_KEYWORDSBYFAULT: (state, keywordsByFault) => {
      state.keywordsByFault = keywordsByFault
    }
  },
  actions: {
    setFaultObj ({ commit }, faultObj) {
      commit('SET_FAULT_OBJ', faultObj)
    },
    setKeywords ({ commit }, faultkeywords) {
      commit('SET_KEYWORDS', faultkeywords)
    },
    setKeywordsByfault ({ commit }, keywordsByFault) {
      commit('SET_KEYWORDSBYFAULT', keywordsByFault)
    }
  }
}

export default fault
